import apiFetch from '@wordpress/api-fetch'
import FrontPageEnum from '../../enumerators/front-page.enum'

export default class StrateCityComponent {
    constructor() {
        StrateCityComponent.init()
    }

    static init() {
        if (
            $(FrontPageEnum.STRATE_SOCIAL_WALL).length > 0 &&
            !$(FrontPageEnum.STRATE_SOCIAL_WALL).is(':hidden') &&
            window.matchMedia('(min-width: 1001px)').matches
        ) {
            apiFetch({
                path: IRISCollectionCustomer.irisSsoInstagramPath,
                method: 'POST',
                data: {
                    limit: 4,
                },
            })
                .then((result) => {
                    $(FrontPageEnum.STRATE_SOCIAL_WALL).html(result.render)
                })
                .catch(() => {
                    $(FrontPageEnum.STRATE_SOCIAL_WALL).html(
                        IRISCollectionCustomer.irisSsoInstagramError,
                    )
                })
        }
    }
}
